import { useQuery } from 'react-query';
import { getSubjectsByBasicClass } from 'api/api';

export const useGetSubjectsByBasicClass = (basicClassId: number, options = {} as any) =>
  useQuery(
    ['subjects', { classId: basicClassId }],
    () => getSubjectsByBasicClass(basicClassId),
    { ...options }
  );
